import { modalActionTypes } from "./modal.types";

export const showModalInfo = modalContent => ({
    type: modalActionTypes.SHOW_MODAL_INFO,
    payload: modalContent
})

export const hideModalInfo = () => ({
    type: modalActionTypes.HIDE_MODAL_INFO
})